import { useState, useEffect } from "react";
import { getLiveByTitleType } from "../../network/lib/photoGallery.js";
import { getPhotoGalleryTypes } from "../../network/lib/masterData.js";
import Slider from "./slider.js";
import { showHideLoader } from "../utils/helper.js";

function PhotoGallery() {
  const [photoGallaryDetails, setPhotoGallaryDetails] = useState();
  const [photoGallaryTypes, setPhotoGallaryTypes] = useState();
  const [selectedValue, setSelectedValue] = useState(1);

  useEffect(() => {
    !photoGallaryTypes && populatePhotoGallaryTypes();
    !photoGallaryDetails && populatePhotoGallaryDetails(1);
  }, []);

  function populatePhotoGallaryTypes() {
    getPhotoGalleryTypes().then((res) => {
      if (res.status == 200) {
        setPhotoGallaryTypes(res.data);
      }
    });
  }

  function populatePhotoGallaryDetails(title) {
    showHideLoader(true);

    getLiveByTitleType(title).then((res) => {
      if (res.status == 200 && res.data) {
        setPhotoGallaryDetails(res.data.length > 0 ? res.data : null);
        showHideLoader();
      }
    });
  }

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    populatePhotoGallaryDetails(event.target.value);
  };

  const types = photoGallaryTypes && (
    <select onChange={handleChange} value={selectedValue}>
      {photoGallaryTypes.map((x, i) => (
        <option key={i + 1} value={x.id}>
          {x.name}
        </option>
      ))}
    </select>
  );

  const sliderItems =
    photoGallaryDetails &&
    photoGallaryDetails.length &&
    photoGallaryDetails.map(
      (x) => `<img src="${x.image}" style="width: 770px; height: 380px;" />`
    );

  const contents = (
    <>
      <div className="Row">
        <div className="Cell">
          <div className="Table">
            <div className="Row">
              <div className="Cell">फोटो प्रकार :</div>
              <div className="Cell">{types}</div>
            </div>
          </div>
        </div>
      </div>
      {photoGallaryDetails && (
        <div className="Row">
          <div className="Cell">
            <div className="photos-gallery">
              {sliderItems && sliderItems != 0 && sliderItems.length && (
                <Slider slides={sliderItems} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );

  return contents;
}

export default PhotoGallery;
